(() => {
  'use strict';

  function directChild(card, className) {
    return Array.from(card.children).find(child => child.classList && child.classList.contains(className)) || null;
  }

  function fixCard(card) {
    if (!(card instanceof Element)) return;

    const vendorRow = directChild(card, 'fhp-top-row');
    const crumbs = directChild(card, 'fhp-crumbs');
    if (!vendorRow || !crumbs) return;

    if (crumbs.nextElementSibling !== vendorRow) {
      card.insertBefore(crumbs, vendorRow);
    }

    card.dataset.ddPdpDesignerOrder = 'breadcrumb-designer-title';
  }

  function boot(root) {
    const scope = root || document;
    if (scope.matches && scope.matches('.fhp-card')) fixCard(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('.fhp-card').forEach(fixCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
